// Gate de ruta genérico por capacidad (ver informe "LYNX — Fase 1.2A:
// Hardening mínimo antes de Producción"). Reemplaza a RequireFinanceAccess
// (que hacía exactamente esto, hardcodeado a finance_access) — mismo
// patrón, una sola capacidad por vez, para cualquiera de las 4 que ya
// existen en server/auth/roles.js (CAPABILITY_PROFILES). No agrega ningún
// permiso ni lógica nueva: solo lee `capabilities`, ya expuesto por
// AuthContext desde GET /v2/auth/capabilities. La autoridad real sigue
// siendo requireAdminPermit(capability) en el backend — esto solo evita
// renderizar la pantalla del lado del cliente (ver informe "LYNX —
// Auditoría de arquitectura: evolución operativa..." no, referencia
// correcta: "Sprint Operativo" — el mismo criterio que ya usaban
// RequireFinanceAccess/RequireReportsAccess: nunca mostrar una puerta que
// el server va a cerrar con 403).
import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth, AdminCapabilities } from "../../context/AuthContext";

type BooleanCapability = Exclude<keyof AdminCapabilities, "profile">;

type RequireCapabilityProps = {
  capability: BooleanCapability;
};

export default function RequireCapability({ capability }: RequireCapabilityProps) {
  const { capabilities, capabilitiesLoading } = useAuth();

  if (capabilitiesLoading) {
    return null;
  }

  if (capabilities?.[capability] !== true) {
    return <Navigate to="/admin" replace />;
  }

  return <Outlet />;
}
